import { BugReportModalBase } from "./BugReportModalBase";

import { useBugReporter } from "utils/hooks/use-bug-reporter";

export const BugReportModalWithNoAv = ({ onClose }: { onClose: () => void }) => (
  <BugReportModalBase useBugReporter={useBugReporter} onClose={onClose} />
);
